import { render, staticRenderFns } from "./polygon3.vue?vue&type=template&id=fd0a9564&scoped=true&"
import script from "./polygon3.vue?vue&type=script&lang=js&"
export * from "./polygon3.vue?vue&type=script&lang=js&"
import style0 from "./polygon3.vue?vue&type=style&index=0&id=fd0a9564&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0a9564",
  null
  
)

export default component.exports